export default "__VITE_ASSET__e1d7745a__"